import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubject,
  updateClassSubject,
  getClassSubject,
} from "../../store/slices/subject";
import { toast } from "react-hot-toast";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

export default function EditClassSubject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [standardId, setStandardId] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [errors, setErrors] = useState({});

  /* ---------- FETCH DATA ---------- */

  useEffect(() => {
    dispatch(getSubject());


    if (id) {
      dispatch(getClassSubject({ id }));
    }


  }, [dispatch, id]);

  const {
    subjectlist = [],
    classsubjectlist = [],
    loading,
  } = useSelector((state) => state.subject || {});

  /* ---------- SET EDIT DATA ---------- */

  useEffect(() => {
    if (
      Array.isArray(classsubjectlist) &&
      classsubjectlist.length > 0
    ) {
      const record = classsubjectlist[0];


      setStandardId(record?.standardId?._id || "");

      const uniqueSubjectIds = [
        ...new Set(
          (record?.subjectId || [])
            .map((subject) => subject?._id)
            .filter(Boolean)
        ),
      ];

      setSelectedSubjects(uniqueSubjectIds);
    }


  }, [classsubjectlist]);

  /* ---------- HANDLE SUBJECT CHANGE ---------- */

  const handleCheckboxChange = (subId) => {
    setSelectedSubjects((prev) => {
      const updatedSubjects = prev.includes(subId)
        ? prev.filter((subjectId) => subjectId !== subId)
        : [...prev, subId];


      // Clear error only when at least one subject is selected
      if (updatedSubjects.length > 0) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors.subjects;
          return newErrors;
        });
      }

      return updatedSubjects;
    });


  };

  /* ---------- VALIDATION ---------- */

  const validate = () => {
    const newErrors = {};


    if (!standardId) {
      newErrors.standardId = "Standard not found";
    }

    if (selectedSubjects.length === 0) {
      newErrors.subjects =
        "Please select at least one subject";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;


  };

  /* ---------- SUBMIT ---------- */

  const handleSubmit = (e) => {
    e.preventDefault();


    if (!validate()) return;

    const payload = {
      id,
      standardId,
      subjectId: selectedSubjects,
    };

    dispatch(updateClassSubject(payload))
      .unwrap()
      .then(() => {
        toast.success("Subjects updated successfully");
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err || "Failed to update subjects");
      });


  };

  return (
    <>
      {/* ---------- HEADER ---------- */}


      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">

            <div className="home-icon">
              <Link to="/institute/home">
                <FiHome
                  style={{
                    color: "white",
                    marginTop: "-4px",
                  }}
                />
              </Link>
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/classsubjects">
              Class Subjects
            </Link>

            <FiChevronRight className="separator" />

            <span className="active">
              Edit Class Subject
            </span>

          </div>
        </div>
      </div>

      {/* ---------- FORM ---------- */}

      <div className="acs-card">

        <Form onSubmit={handleSubmit}>

          <Row className="g-3">

            {/* ---------- STANDARD ---------- */}

            <Col md={3} sm={12}>
              <Form.Group>

                <Form.Label>
                  Standard
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    classsubjectlist.length
                      ? classsubjectlist[0]?.standardId?.name || ""
                      : ""
                  }
                  disabled
                />

                {errors.standardId && (
                  <small className="text-danger">
                    {errors.standardId}
                  </small>
                )}

              </Form.Group>
            </Col>

            {/* ---------- SUBJECTS ---------- */}

            <Col md={12}>
              <Form.Group>

                <Form.Label>
                  Subjects
                </Form.Label>

                <div className="sa-checkbox-grid">

                  {subjectlist.map((sub) => (

                    <label
                      key={sub._id}
                      className="sa-checkbox-item"
                    >
                      <input
                        type="checkbox"
                        checked={selectedSubjects.includes(sub._id)}
                        onChange={() =>
                          handleCheckboxChange(sub._id)
                        }
                      />

                      <span>
                        {sub.name}
                      </span>

                    </label>

                  ))}

                </div>

                {errors.subjects && (
                  <small className="text-danger">
                    {errors.subjects}
                  </small>
                )}

              </Form.Group>
            </Col>

          </Row>

          {/* ---------- ACTIONS ---------- */}

          <div className="sa-actions mt-5">

            <button
              type="button"
              className="btn-cancel"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn-submit"
              disabled={loading}
            >
              Update
            </button>

          </div>

        </Form>

      </div>
    </>


  );
}
